export const PURCHASE_STATUS_PAYMENT_CHARGED = 'Payment_Charged';
export const PURCHASE_STATUS_CANCELED_AFTER_PURCHASE = 'Canceled_After_Purchase';
export const PURCHASE_STATUS_DISPUTE_PURCHASE = 'Dispute_Purchase';
export const PURCHASE_STATUS_PAUSE_PAYMENTS_CHARGING = 'Pause_Payments_charging';

export const PAYMENT_PLAN_STATUS_PENDING_PAYMENTS  = 'Pending_Payments';
export const PAYMENT_PLAN_STATUS_ON_SCHEDULE  = 'On_Schedule';
export const PAYMENT_PLAN_STATUS_LATE  = 'Late';
export const PAYMENT_PLAN_STATUS_DEFAULT  = 'Default';
export const PAYMENT_PLAN_STATUS_PAID_OFF = 'Paid_Off';
export const PAYMENT_PLAN_STATUS_CHARGE_FAILED = 'Charge_Failed';

export const PURCHASE_STATUS_MERGED_ON_SCHEDULE = 'PURCHASE_STATUS_MERGED_ON_SCHEDULE';
export const PURCHASE_STATUS_MERGED_LATE = 'PURCHASE_STATUS_MERGED_LATE';
export const PURCHASE_STATUS_MERGED_DEFAULT = 'PURCHASE_STATUS_MERGED_DEFAULT';
export const PURCHASE_STATUS_MERGED_CANCELED = 'PURCHASE_STATUS_MERGED_CANCELED';
export const PURCHASE_STATUS_MERGED_DISPUTE = 'PURCHASE_STATUS_MERGED_DISPUTE';
export const PURCHASE_STATUS_MERGED_PAUSED = 'PURCHASE_STATUS_MERGED_PAUSED';
export const PURCHASE_STATUS_MERGED_PAID = 'PURCHASE_STATUS_MERGED_PAID';
export const PURCHASE_STATUS_MERGED_UNKNOWN = 'PURCHASE_STATUS_MERGED_UNKNOWN';

export const mergedStatusToText = {
  PURCHASE_STATUS_MERGED_ON_SCHEDULE: 'purchase.info.status.onSchedule',
  PURCHASE_STATUS_MERGED_LATE: 'purchase.info.status.late',
  PURCHASE_STATUS_MERGED_DEFAULT: 'purchase.info.status.default',
  PURCHASE_STATUS_MERGED_CANCELED: 'purchase.info.status.canceled',
  PURCHASE_STATUS_MERGED_DISPUTE: 'purchase.info.status.dispute',
  PURCHASE_STATUS_MERGED_PAUSED: 'purchase.info.status.paused',
  PURCHASE_STATUS_MERGED_PAID: 'purchase.info.status.paid',
  PURCHASE_STATUS_MERGED_UNKNOWN: 'purchase.info.status.unknown'
};

export const originators = {
  'MERCHANT': 'MERCHANT',
  'TAB': 'TAB',
};

export const PURCHASE_DOCUMENT_TYPE_GENERATED = 'PURCHASE_DOCUMENT_TYPE_GENERATED';
export const PURCHASE_DOCUMENT_TYPE_CUSTOM_POPUP = 'PURCHASE_DOCUMENT_TYPE_CUSTOM_POPUP';
export const PURCHASE_DOCUMENT_TYPE_POPUP = 'PURCHASE_DOCUMENT_TYPE_POPUP';

export const PURCHASE_DOCUMENT_CATEGORY_AGREEMENT = 'PURCHASE_DOCUMENT_CATEGORY_AGREEMENT';
export const PURCHASE_DOCUMENT_CATEGORY_PRIVACY = 'PURCHASE_DOCUMENT_CATEGORY_PRIVACY';
export const PURCHASE_DOCUMENT_CATEGORY_CONSENTS = 'PURCHASE_DOCUMENT_CATEGORY_CONSENTS';

export const purchaseDocuments = [
  {
    category: 'PURCHASE_DOCUMENT_CATEGORY_AGREEMENT',
    name: 'Retail Installment Contract',
    type: PURCHASE_DOCUMENT_TYPE_GENERATED,
    notification: 'com.sunbit.notification.purchase.Agreement',
    documentType: 'com.sunbit.notification.purchase.Agreement.RIC',
  },
  {
    category: 'PURCHASE_DOCUMENT_CATEGORY_AGREEMENT',
    name: 'Installment Loan Agreement',
    type: PURCHASE_DOCUMENT_TYPE_GENERATED,
    notification: 'com.sunbit.notification.purchase.Agreement',
    documentType: 'com.sunbit.notification.purchase.Agreement.TAB',
  },
  {
    category: 'PURCHASE_DOCUMENT_CATEGORY_AGREEMENT',
    name: 'Correction Notice',
    type: PURCHASE_DOCUMENT_TYPE_CUSTOM_POPUP,
    failMessage: 'purchase.document.correction.error',
    notification: 'com.sunbit.notification.purchase.TILA',
    documentType: 'com.sunbit.notification.purchase.TILA.TILA'
  },
  {
    category: 'PURCHASE_DOCUMENT_CATEGORY_PRIVACY',
    name: 'Sunbit Privacy Policy',
    type: PURCHASE_DOCUMENT_TYPE_GENERATED,
    notification: 'com.sunbit.notification.purchase.Agreement',
    documentType: 'com.sunbit.notification.purchase.Agreement.Privacy'
  },
  {
    category: 'PURCHASE_DOCUMENT_CATEGORY_PRIVACY',
    name: 'GLBA Privacy Notice',
    type: PURCHASE_DOCUMENT_TYPE_GENERATED,
    notification: 'com.sunbit.notification.purchase.Agreement',
    documentType: 'com.sunbit.notification.purchase.Agreement.GLBA'
  },
  {
    category: 'PURCHASE_DOCUMENT_CATEGORY_PRIVACY',
    name: 'TAB Bank GLBA Notice',
    type: PURCHASE_DOCUMENT_TYPE_GENERATED,
    notification: 'com.sunbit.notification.purchase.Agreement',
    documentType: 'com.sunbit.notification.purchase.Agreement.GLBA.TAB'
  },
  {
    category: 'PURCHASE_DOCUMENT_CATEGORY_CONSENTS',
    name: 'Credit Pull Authorization',
    type: PURCHASE_DOCUMENT_TYPE_GENERATED,
    notification: 'com.sunbit.notification.purchase.Agreement',
    documentType: 'com.sunbit.notification.purchase.Agreement.CPA'
  },
  {
    category: 'PURCHASE_DOCUMENT_CATEGORY_PRIVACY',
    name: 'Sunbit Online Services Terms of Use',
    notification: 'com.sunbit.notification.purchase.Agreement',
    documentType: 'com.sunbit.notification.Sunbit_Online_Services_Terms_of_Use',
  },
  {
    category: 'PURCHASE_DOCUMENT_CATEGORY_PRIVACY',
    name: 'ESIGN Consent',
    type: PURCHASE_DOCUMENT_TYPE_GENERATED,
    notification: 'com.sunbit.notification.purchase.Agreement',
    documentType: 'com.sunbit.notification.purchase.Agreement.Electronic.Consent',
  },
  {
    category: 'PURCHASE_DOCUMENT_CATEGORY_PRIVACY',
    name: 'Arbitration Agreement',
    type: PURCHASE_DOCUMENT_TYPE_GENERATED,
    notification: 'com.sunbit.notification.purchase.Agreement',
    documentType: 'com.sunbit.notification.purchase.Agreement.Arbitration.Agreement',
  },
  {
    category: 'PURCHASE_DOCUMENT_CATEGORY_AGREEMENT',
    name: 'Multiple Installment Loan Payment Disclosure',
    type: PURCHASE_DOCUMENT_TYPE_GENERATED,
    notification: 'com.sunbit.notification.loan',
    documentType: 'com.sunbit.notification.loan.payment.disclosure',
  }
];




// WEBPACK FOOTER //
// ./src/purchases/constants.js